module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    ref: "scrollBar",
    staticClass: "landing"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "landing-scroll-cnt",
    on: {
      "scroll": _vm.onScroll,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_c('div', {
    staticClass: "landing-bg"
  }, [_c('Rules', {
    attrs: {
      "id": "Rules"
    }
  }), _vm._v(" "), _c('Test', {
    attrs: {
      "id": "Test",
      "canAnimate": _vm.canAnimate
    }
  })], 1), _vm._v(" "), _c('VideoComponent', {
    attrs: {
      "id": "Video",
      "canAnimate2": _vm.canAnimate2
    }
  }), _vm._v(" "), _c('Product', {
    attrs: {
      "id": "Product",
      "canAnimate3": _vm.canAnimate3
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2f8ca6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing.vue
// module id = 504
// module chunks = 1